import { render, staticRenderFns } from "./PatientFiles.vue?vue&type=template&id=32457e78&scoped=true"
import script from "./PatientFiles.vue?vue&type=script&lang=js"
export * from "./PatientFiles.vue?vue&type=script&lang=js"
import style0 from "./PatientFiles.scss?vue&type=style&index=0&id=32457e78&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32457e78",
  null
  
)

export default component.exports